import { useArticleContext } from '@prishapolicy/w3/ui';
import Image, { ImageProps } from 'next/image';
export const Img = (props: ImageProps) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const frontMatter = useArticleContext()!;

  const src = props.src.toString();

  return (
    <Image
      src={src.startsWith('http') ? src : `/blog-assets/${frontMatter?.slug}/${src}`}
      alt={props.alt}
      width={800}
      height={400}
      style={{
        aspectRatio: 2 / 1,
      }}
    />
  );
};

export default Img;
